export default __webpack_public_path__ + "static/media/fortune-10 1.7f8b54cf.svg";